import {
  Color,
  ComboboxSingleSelect,
  Icons
} from '@eggplant/pattern-library'
import {
  HiCheckCircle,
  HiExclamation,
  HiExclamationCircle,
  HiXCircle
} from 'react-icons/hi'
import type { ComponentProps } from 'react'
import type {
  DropdownPlacement,
  Options,
  TestStatus
} from '@eggplant/types'

interface Props {
  value: string | undefined
  onChange: (value: TestStatus | string) => void
  dropdownPlacement?: DropdownPlacement
}

const dropDownIcon = () =>
  <Icons.TestStatus
    aria-hidden
    size='20px'
  />

const inProgressIcon = () => <Icons.InProgressCircle aria-hidden />

type colors = ComponentProps<typeof Color>['variant']

const statusToColorMap = {
  Cancelled: 'greyC',
  Error: 'orange',
  Passed: 'secondarygreen',
  Fail: 'redHover',
  'In Progress': 'purple'
}

const iconMap = {
  Cancelled: HiXCircle,
  'In Progress': inProgressIcon,
  Error: HiExclamation,
  Fail: HiExclamationCircle,
  Passed: HiCheckCircle
}

const titles = {
  CANCELLED: 'Cancelled',
  ERROR: 'Error',
  FAILED: 'Fail',
  INCOMPLETE: 'In Progress',
  PASSED: 'Passed'
}

const statusOptions: Options = [
  {
    label: 'Passed',
    value: 'PASSED'
  },
  {
    label: 'Failed',
    value: 'FAILED'
  },
  {
    label: 'In Progress',
    value: 'INCOMPLETE'
  },
  {
    label: 'Error',
    value: 'ERROR'
  },
  {
    label: 'Cancelled',
    value: 'CANCELLED'
  }
]

const statusOptionsWithIcons = statusOptions.map(
  (item, index) => {
    const Icon = iconMap[titles[item.value as keyof typeof titles] as keyof typeof iconMap]
    const variant = statusToColorMap[titles[item.value as keyof typeof titles] as keyof typeof statusToColorMap] as colors

    return {
      ...item,
      trailingIcon: (
        <Color
          key={index}
          variant={variant}
        >
          <Icon
            aria-hidden
            size={18}
          />
        </Color>
      )
    }
  }
) as Options

const SelectTestResultsStatus = ({
  onChange,
  value,
  dropdownPlacement = 'bottom'
}: Props) =>
  <ComboboxSingleSelect
    Icon={dropDownIcon}
    ariaLabel='Run Status Combobox'
    categoryLabel='Status'
    dropdownPlacement={dropdownPlacement}
    isFilter
    isFilterFixedMinMaxWidth={false}
    isHighlighted={value !== ''}
    key={value}
    onChange={onChange}
    options={statusOptionsWithIcons}
    prompt='Run status'
    value={value}
  />

export default SelectTestResultsStatus
